@if (chartOptions()) {
  <highcharts-chart [style]="chartStyle()"
    [constructorType]="chartConstructor()" [options]="$any(mergedOptions)"
    (chartInstance)="setChart($event)"></highcharts-chart>
}